/**
 * OCHAT: la ruta de la guía propia.
 *
 * Va bajo `accounts/:accountId` como el resto del dashboard, y no en la raíz,
 * porque el guard de upstream (validateLoggedInRoutes) resuelve la cuenta desde
 * `to.params.accountId`: sin ese parámetro no encuentra cuenta y manda al login.
 *
 * `meta.permissions` incluye a los tres niveles a propósito. La guía es de lectura
 * y el agente es justamente quien más la va a usar. Nada de acá lo pasa la política
 * de rutas de ochat/routes/routePermissionPolicy.js, porque `ochat_guide` no
 * coincide con ningún patrón reservado.
 */
import { frontendURL } from 'dashboard/helper/URLHelper';
import { SUPER_ADMIN_PERMISSION } from '../config/permissions';
import GuidePage from './GuidePage.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/guide/:topic'),
    name: 'ochat_guide',
    component: GuidePage,
    meta: {
      permissions: ['administrator', 'agent', SUPER_ADMIN_PERMISSION],
    },
  },
];

export default { routes };
